import { IApiError } from '@/models/apiError.model';
import { IBaseActionLog } from '@/models/logs.model';
import { IPagination } from '@/models/pagination.model';

export const LOGS_SLICE_NAME = 'logs';

export interface LogsState {
  actionLogs: IBaseActionLog[] | null;
  pagination: IPagination | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: LogsState = {
  pagination: null,
  actionLogs: null,
  isLoading: false,
  error: null,
};
